<template>
  <footer class="blog-post__footer">
    <!-- <TagsList class="blog-post__footer-tags" :tags="tags"/> -->
    <!--        <Share />-->
    <discuss v-if="article.discuss_link" :link="article.discuss_link" />
    <a
      href="#go-top"
      class="back-top iconmoon-backtotop pull-right"
      @click.prevent="srtollTop"
    ></a>
  </footer>
</template>

<script>
// import Share from './Share.vue';
import Discuss from "@/components/common/article/widgets/Discuss.vue";

export default {
  components: {
    Discuss,
    // Share
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
  },
  methods: {
    srtollTop() {
      this.$emit("srtollTop");
    },
  },
};
</script>

<style scoped lang="scss">
@import "./../../../assets/styles/vars";

$h-padding: 100px;
$v-padding: 40px;
$screen-big: 1270px;

.blog-post__footer-tags {
  margin-bottom: 20px;
}

.back-top {
  position: absolute;
  bottom: -80px;
  left: 79%;
  padding: 25px;
  text-align: center;
  font-size: 22px;
  color: #fff;
  background-color: #000;

  &:hover,
  &:focus {
    color: $mainRed;
    text-decoration: none;
  }
}
</style>
